// extracted by mini-css-extract-plugin
export default {"Emojify":"bca_a bib_g"};